var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginLeftPolygonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.284,
    height: 68.462,
    viewBox: "0 0 65.284 68.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3a54fe;}.b{fill:#fff;}.c{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f3eee2",
    floodOpacity: 0.502,
    result: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27,0,54,48H0Z",
    transform: "translate(0 49.707) rotate(-67)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27,0,54,48H0Z",
    transform: "translate(0 49.71) rotate(-67)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLeftPolygonIcon);
export default __webpack_public_path__ + "static/media/login-left-polygon-icon.9ba604db171f370a5e31b732fd53d687.svg";
export { ForwardRef as ReactComponent };